import React from 'react';
import Link from 'Components/Shared/Link/Link';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';
import { IMenu } from 'Components/MenuFooter/MenuFooter';

const VerticalMenu: React.SFC<IMenu> = ({ 
  displayName, 
  formattedName,
  imageUrl,
  items,
}) => {
  return (
    <div className='vertical-menu'>
      { imageUrl && <img alt='Julius Biljettservice logga' src={ imageUrl } />  }
      <div className='items'>
        <FormattedText style='title' { ... { displayName, formattedName } } />
        { items.map(i => <Link key={ i.id } { ...i } />) }
      </div>
    </div>
  );
};

export default VerticalMenu;


// WEBPACK FOOTER //
// ./src/components/MenuFooter/SubMenues/VerticalMenu.tsx